import { Skeleton } from '@gravity-ui/uikit';
import styles from './styles.module.scss';

export const AdminTableLoaderAdaptive = () => {
	return (
		<div className={styles.admin_table_loader}>
			<div className={styles.admin_table_loader__container}>
				<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
					<div style={{ width: '100%' }}>
						<Skeleton style={{ maxWidth: '247px', height: '42px' }} />
					</div>

					<div style={{ display: 'flex', gap: '16px', width: '100%' }}>
						<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
						<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
					</div>
				</div>

				<Skeleton style={{ maxWidth: '696px', height: '42px' }} />

				<div style={{ display: 'flex', gap: '24px' }}>
					<Skeleton style={{ maxWidth: '336px', height: '42px' }} />
					<Skeleton style={{ maxWidth: '336px', height: '42px' }} />
				</div>
			</div>
			<div className={styles.admin_table_loader__container}>
				<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
					<div style={{ width: '100%' }}>
						<Skeleton style={{ maxWidth: '247px', height: '42px' }} />
					</div>

					<div style={{ display: 'flex', gap: '16px', width: '100%' }}>
						<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
						<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
					</div>
				</div>

				<Skeleton style={{ maxWidth: '696px', height: '42px' }} />

				<div style={{ display: 'flex', gap: '24px' }}>
					<Skeleton style={{ maxWidth: '336px', height: '42px' }} />
					<Skeleton style={{ maxWidth: '336px', height: '42px' }} />
				</div>
			</div>
			<div className={styles.admin_table_loader__container}>
				<div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
					<div style={{ width: '100%' }}>
						<Skeleton style={{ maxWidth: '247px', height: '42px' }} />
					</div>

					<div style={{ display: 'flex', gap: '16px', width: '100%' }}>
						<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
						<Skeleton style={{ maxWidth: '44px', height: '44px' }} />
					</div>
				</div>

				<Skeleton style={{ maxWidth: '696px', height: '42px' }} />

				<div style={{ display: 'flex', gap: '24px' }}>
					<Skeleton style={{ maxWidth: '336px', height: '42px' }} />
					<Skeleton style={{ maxWidth: '336px', height: '42px' }} />
				</div>
			</div>
		</div>
	);
};
